<app-layout-page>
  <app-layout-header [showBackButton]="true">
  </app-layout-header>

  <app-layout-content class="content" [formGroup]="form">
    <h2 trans="email_mfa.title">(title)</h2>

    @if (email) {
      <p class="instructions" trans="email_mfa.instructions.email_available"></p>
    }
    @if (!email) {
      <p class="instructions" trans="email_mfa.instructions.email_not_available"></p>
    }

    @if (email) {
      <p class="email-display">{{ email }}</p>
    }

    <nom-otp-input
      [control]="pinInput"
      [errors]="errors.otpInputErrors()"
    ></nom-otp-input>

    @if (showResentMessage) {
      <app-icon-message
        messageType="alert"
        transMessage="email_mfa.error.resent_email"
      ></app-icon-message>
    }

    @if (sendEmailError) {
      <app-icon-message messageType="alert">
        <span trans="email_mfa.error.could_not_send.start"></span>
        <a (click)="sendEmail()" trans="email_mfa.error.could_not_send.button">(link)</a>
        <span trans="email_mfa.error.could_not_send.end"></span>
      </app-icon-message>
    }

    @if (emailResendLimitError) {
      <app-icon-message
        messageType="alert"
        transMessage="email_mfa.error.resend_limit"
      ></app-icon-message>
    }

    @if (canResendEmail) {
      <div class="resend-area">
        @if (!isSendingEmail) {
          <a class="resend-link" (click)="sendEmail()" trans="email_mfa.button.resend">(link)</a>
        }
        @if (isSendingEmail) {
          <span class="resend-msg" trans="email_mfa.resend_confirmation"></span>
        }
      </div>
    }
  </app-layout-content>

  <app-layout-buttons>
    @if (couldNotVerifyError || timeoutError) {
      <app-icon-message messageType="alert">
        @if (couldNotVerifyError) {
          <span trans="email_mfa.error.could_not_verify"></span>
        }
        @if (timeoutError) {
          <span trans="email_mfa.error.timeout"></span>
        }
      </app-icon-message>
    }

    <button
      class="btn btn-primary pull-center"
      (click)="verify()"
      [disabled]="form.invalid || busy"
      [appFocus]="form.valid"
      [trans]="busy ? 'email_mfa.button.verifying' : 'email_mfa.button.verify'"
    ></button>
  </app-layout-buttons>
</app-layout-page>
